export default "__VITE_ASSET__BdPtY4IR__"